<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 offset-lg-2">

        <div class="card mt-4">
          <div class="card-body">
            <h3 class="card-title">{{ product.name }}</h3>
          </div>
          <transition name="component-fade" mode="out-in">
            <img class="card-img-bottom img-fluid mb-3"
               style="max-width: 300px;display: block; margin: 0 auto;"
               v-if="bigImage.path"
               :src="`/${bigImage.path}`"
               :alt="bigImage.desc"
               :key="bigImage._id"
            >
          </transition>
          <p class="text-center">
            {{bigImage.desc}}
          </p>
        </div>
        <ul class="d-flex mt-4 p-0" v-if="additionalImages.length > 1">
          <li
              class="card p-1 prev-wrapper"
              v-for="(img, index) in additionalImages"
              :class="{
                'mr-0': (index+1)%3 === 0,
                'mr-2': (index+1)%3 !== 0,
                'active': img._id === activeId,
              }"
              :key="img._id"
              @click="setActiveImage(img._id)"
          >
            <img
                style="max-width: 100%;display: block; margin: 0 auto;"
                :src="`/${img.image.path.slice(5)}`" alt="">
          </li>
        </ul>
      </div>
        <!-- /.card -->
      <div class="col-lg-4">
        <div class="card card-outline-secondary my-4">
          <div class="card-header">
            {{fields.product_description}}
          </div>
          <div class="card-body">
            <p class="card-text">{{ product.full_description || '-' }}</p>
          </div>
        </div>

        <div class="card card-outline-secondary my-4">
          <div class="card-header">
            {{fields.product_info}}
          </div>
          <div class="card-body">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <strong>{{fields.brand}}:</strong>
                <span>
                  {{ product.brand || '-' }}
                </span>
              </li>
              <li class="list-group-item">
                <strong>{{fields.category}}:</strong>
                <span>
                  {{ product.category || '-' }}
                </span>
              </li>
              <li class="list-group-item">
                <strong>{{fields.composition}}:</strong>
                <span>
                  {{ product.composition || '-' }}
                </span>
              </li>
              <li class="list-group-item">
                <strong>{{fields.country_of_production}}:</strong>
                <span>
                  {{ product.country_of_production || '-' }}
                </span>
              </li>
              <li class="list-group-item d-flex">
                <strong class="mr-1">{{fields.packaging}}:</strong>
                <span
                  v-if="additionalImages.length"
                  class="d-flex flex-column "
                >
                  <span
                    class="package d-inline mb-2"
                    v-for="item in additionalImages"
                    :key="item._id"
                    :class="{'active': item._id === activeId}"
                    @click="setActiveImage(item._id)"
                  >
                    <span>{{ item.name }}</span>
                  </span>
                </span>
                <span v-else>
                  {{ product.packaging || '-' }}
                </span>
              </li>
              <li class="list-group-item">
                <strong>{{fields.region}}:</strong>
                <span>
                  {{ product.region || '-' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import store from '@/store';
import Api from '@/api';
import filterObject from '@/util/lang';

export default {
  name: 'Product',
  data() {
    return {
      additionalImages: [],
      activeId: '',
      bigImage: {
        path: '',
        _id: '',
        desc: '',
      },
      fields: {},
    };
  },
  methods: {
    setActiveImage(id) {
      const temp = this.additionalImages.find(image => image._id === id);
      this.bigImage.path = temp.image.path.slice(5);
      this.bigImage._id = temp._id;
      this.bigImage.desc = temp.name;
      this.activeId = temp._id;
    },
    getContent() {
      Api.getProductPageFields()
        .then(fieldsObj => filterObject(fieldsObj, store.getters.lang))
        .then((localizedFieldObj) => {
          this.fields = Object.assign({}, localizedFieldObj);
        });
      if (this.product.package_images) {
        const array = [];
        this.product.package_images.forEach((sliderImage) => {
          array.push(Api.getPackageImageById(sliderImage._id));
        });
        Promise.all(array)
          .then(data => data.map(obj => filterObject(obj, store.getters.lang)))
          .then((images) => {
            this.additionalImages = images;
          });
      }
    },
  },
  mounted() {
    this.getContent();
    store.watch(state => state.lang, () => {
      this.getContent();
    });
  },
  computed: {
    product() {
      return store.getters.currentProduct;
    },
  },
  watch: {
    additionalImages: {
      immediate: true,
      handler() {
        if (this.additionalImages.length) {
          this.bigImage.path = this.additionalImages[0].image.path.slice(5);
          this.bigImage._id = this.additionalImages[0]._id;
          this.bigImage.desc = this.additionalImages[0].name;
          this.activeId = this.bigImage._id;
        } else if (!this.product.package_images) {
          this.bigImage.path = this.product.image.path.slice(5);
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
  .prev-wrapper {
    max-width: 33%;
    transition: transform ease-in 0.3s;
    &:hover {
      cursor: pointer;
      transform: scale(1.05);
    }
    &.active {
      border: 1px solid #40312E;
    }
  }
  .package {
    span {
      border-bottom: 1px dashed ;
    }
    &:hover {
      cursor: pointer;
    }
    &.active span {
      border-bottom-width: 2px;
    }
  }
</style>
